import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { fmtInt } from "@/lib/api";

export default function OrdersPagination({
  total, page, totalPages, rangeStart, rangeEnd,
  pageSize, onPageSizeChange, setPage, loading,
}) {
  return (
    <div className="flex items-center justify-between mt-4 flex-wrap gap-3" data-testid="orders-pagination">
      <div className="text-xs text-zinc-500 font-mono">
        {rangeStart}–{rangeEnd} de {fmtInt(total)} pedido{total === 1 ? "" : "s"}
      </div>
      <div className="flex items-center gap-2">
        <span className="overline text-zinc-500">EXIBIR</span>
        <select
          className="input w-auto"
          value={pageSize}
          onChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))}
          data-testid="page-size-select"
        >
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={200}>200</option>
          <option value={500}>500</option>
        </select>
        <button
          className="btn btn-ghost px-2"
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          disabled={page <= 1 || loading}
          data-testid="prev-page-btn"
          aria-label="Página anterior"
        >
          <CaretLeft size={16} weight="bold" />
        </button>
        <span className="font-mono text-sm w-20 text-center" data-testid="page-indicator">
          {page} / {totalPages}
        </span>
        <button
          className="btn btn-ghost px-2"
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          disabled={page >= totalPages || loading}
          data-testid="next-page-btn"
          aria-label="Próxima página"
        >
          <CaretRight size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
}
